import { numberToPrettyString } from '@cian/utils';

import { isCommercialLand } from './isCommercialLand';
import { IOffer } from '../../../types/offer';

function roundArea(value: number): number {
  return Math.round(value * 10) / 10;
}

export function getCommercialTotalArea(offer: IOffer): string | undefined {
  if (isCommercialLand(offer)) {
    const area = offer.land?.area;

    if (area == null) {
      return undefined;
    }

    const unit = offer.land?.areaUnitType === 'hectare' ? 'га' : 'сот.';

    return `${numberToPrettyString(roundArea(Number(area)))} ${unit}`;
  }

  if (!offer.totalArea) {
    return undefined;
  }

  return `${numberToPrettyString(roundArea(Number(offer.totalArea)))} м²`;
}
